import React from "react";
import { StyleSheet, TouchableHighlight, View, Platform } from "react-native";
import { FontAwesomeIcon } from "../../platform";
import { COLORS as DEFAULT_COLORS } from "../theme/colors";
import { COLORS as APP_COLORS } from "../../theme/colors";

const COLORS = { ...DEFAULT_COLORS, ...APP_COLORS };
const iconSize = Platform.OS === "web" ? "xl" : 25;

/**
 * PrimaryButton Component
 * Renders a button with a primary color and onPress functionality.
 * @param {string} icon - The icon to display on the button.
 * @param {function} onPress - The function to execute when the button is pressed.
 * @param {string} iconColor - Optional color for the icon (defaults to COLORS.onPrimary).
 * @returns {JSX.Element} A styled button component.
 */
const FabButton = ({ icon, onPress, customStyle, accessibilityLabel, testID, iconColor }) => {
  return (
    <TouchableHighlight
      style={[styles.button, customStyle]}
      testID={testID}
      onPress={onPress}
      underlayColor={COLORS.primaryVariant}
      accessible={true}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
    >
      <View style={styles.iconContainer}>
        <FontAwesomeIcon size={iconSize} icon={icon} color={iconColor || COLORS.onPrimary} />
      </View>
    </TouchableHighlight>
  );
};

const styles = StyleSheet.create({
  button: {
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 10,
    borderRadius: 12,
    borderWidth: 1,
    minWidth: 30,
    paddingHorizontal: 10,
    backgroundColor: COLORS.primary,
    borderColor: COLORS.border,
  },
  iconContainer: {
    justifyContent: "center",
    alignItems: "center",
    width: 40,
    height: 40,
  },
});

export default FabButton;
